import React, { useEffect } from 'react';

const WbModal = ({ className, show, children }) => {
  useEffect(() => {
    if (show) {
      document.body.classList.add('modal-open');
    } else {
      document.body.classList.remove('modal-open');
    }
    return () => document.body.classList.remove('modal-open');
  }, [show]);

  if (!show) {
    return null;
  }

  return (
    <>
      {show && <div className="modal-backdrop am-fade" />}
      <div
        className={`modal ${!show ? 'hidden' : ''} ${className}`}
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">{children}</div>
          </div>
        </div>
      </div>
    </>
  );
};

WbModal.defaultProps = {
  className: '',
  show: false,
};

export default WbModal;
